import { QueryClient } from "@tanstack/react-query";
import { ApiClientError } from "./client.js";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        // Don't retry client-side auth / validation errors — only transient
        // network / 5xx hiccups.
        retry: (failureCount, error) => {
          if (error instanceof ApiClientError) {
            if (error.status >= 400 && error.status < 500) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
